import * as React from "react";

const Filament = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer6-4"
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeOpacity="1"
      display="inline"
      transform="translate(-4.827 .465)"
    >
      <ellipse
        id="path16-5-1"
        cx="8.002"
        cy="3.948"
        fill="none"
        stroke="#000"
        strokeDasharray="none"
        strokeDashoffset="0"
        strokeWidth="0.4"
        rx="2.646"
        ry="1.143"
      ></ellipse>
      <ellipse
        id="path17-4"
        cx="8.002"
        cy="1.473"
        fill="none"
        stroke="#000"
        strokeDasharray="none"
        strokeDashoffset="0"
        strokeWidth="0.4"
        opacity="1"
        rx="1.058"
        ry="0.365"
      ></ellipse>
      <path
        id="rect18-3"
        fill="#fff"
        fillOpacity="1"
        stroke="none"
        strokeDasharray="none"
        strokeDashoffset="0"
        strokeWidth="0.241"
        d="M6.35 2.616h3.304v.779H6.35z"
        opacity="1"
      ></path>
      <ellipse
        id="path16-59"
        cx="8.002"
        cy="1.473"
        fill="none"
        stroke="#000"
        strokeDasharray="none"
        strokeDashoffset="0"
        strokeWidth="0.4"
        display="inline"
        opacity="1"
        rx="2.646"
        ry="1.143"
      ></ellipse>
      <path
        id="path19-3"
        fill="none"
        fillOpacity="1"
        stroke="#000"
        strokeDasharray="none"
        strokeDashoffset="0"
        strokeWidth="0.4"
        d="M6.15 4.033c1.058.53 2.646.53 3.704 0m0-1.744v1.744M6.15 2.29v1.744"
        opacity="1"
      ></path>
      <path
        id="path1-6-7"
        fill="none"
        fillOpacity="1"
        stroke="#000"
        strokeDasharray="0.80000001,0.80000001"
        strokeDashoffset="0.44"
        strokeWidth="0.4"
        d="M6.25 3.176c1.058.53 2.646.53 3.704 0"
      ></path>
    </g>
  </svg>
);

export default Filament;
